import {
  Box,
  Button,
  FormControlLabel,
  Radio,
  RadioGroup,
  Typography,
} from "@mui/material";
import React, { ReactElement, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { T } from "react-translator-component";
import GCBackButton from "../../components/GreenCity/GCBackButton";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import { colors } from "../../common/colors";

import { useSelector } from "react-redux";
import { useAppDispatch } from "../../redux/store";
import { setGroupInfo } from "../../redux/Reducers/gcGroupReducer";
import { styles } from "../styles";

const defaultImage = require("../../assets/images/default.png");
function CreateGroupStepPII(): ReactElement {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const { user } = useSelector((state: any) => state.userAuth);
  const groupInfo = useSelector((state: any) => state.gcGroup);
  const [image, setImage] = useState<any>();
  const [pIIRequired, setRequired] = useState<string>("");
  useEffect(() => {
    if (typeof groupInfo?.piiRequired === "boolean") {
      setRequired(groupInfo?.piiRequired ? "YES" : "NO")
    } else {
      if (groupInfo?.edit) {
        setRequired(groupInfo?.piiRequired)
      } else {
        setRequired(groupInfo?.piiRequired ? "YES" : "NO")
      }
    }
    window.scrollTo(0, 0);
    // eslint-disable-next-line
  }, []);

  // Handle change for each field
  const handle3PIIChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setRequired((event.target as HTMLInputElement).value);
  };

  const handleNextStep = () => {
    dispatch(
      setGroupInfo({
        piiRequired: pIIRequired === "YES",
      })
    );

    navigate("/creategroupsteptwo");
  };

  useEffect(() => {
    const icon = groupInfo?.groupImage instanceof File ? URL.createObjectURL(groupInfo.groupImage) : defaultImage;
    setImage(icon); // Set the image URL
  }, [groupInfo]);
  return (
    <div style={{ paddingTop: 100, height: "100vh" }}>
      <Box>
        <GCBackButton onClick={() => navigate(-1)} />
        <Box
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            padding: 16,
            borderBottomColor: colors.farm_gray15,
            borderBottomWidth: 1,
            borderBottomStyle: "solid",
          }}
        >
          <div
            style={{
              display: "flex",
              justifyContent: "flex-start",
              alignItems: "center",
            }}
          >
            <img
              alt=""
              style={{
                height: 32,
                width: 32,
                borderRadius: 18,
                borderWidth: 1,
                borderStyle: "solid",
                borderColor: colors.farm_green500,
              }}
              src={image || defaultImage}
            />
            <Typography style={{ fontSize: 14, fontWeight: 600 }}>
              &nbsp;{groupInfo.groupName}
            </Typography>
          </div>
        </Box>
        <Box style={{ padding: 20 }}>
          <Typography style={{ fontSize: 12, }}>
            {T("create_group_pii_description")}
          </Typography>
          <br></br>
          <RadioGroup
            aria-labelledby="radio-buttons-group-label"
            value={pIIRequired}
            onChange={handle3PIIChange}
            name="radio-buttons-group"
          >
            <FormControlLabel
              value="NO"
              disabled={groupInfo?.id ? true : false}
              sx={{ paddingBottom: 4 }}
              control={<Radio />}
              label={T("create_group_pii_no")}
            />
            <FormControlLabel
              value="YES"
              disabled={(!user.name || groupInfo?.id) ? true : false}
              control={<Radio />}
              label={T("create_group_pii_yes")}
            />
          </RadioGroup>
        </Box>
        <Box
          style={{
            display: "flex",
            justifyContent: "center",
          }}
        >
          <Button
            onClick={() => {
              handleNextStep();
            }}
            style={{
              ...styles.introSliderBtn,
              marginTop: 40,
              width: 220,
            }}
            size={"large"}
            variant="contained"
            endIcon={<ArrowForwardIosIcon />}
          >
            <span style={{ paddingRight: 30, paddingLeft: 40 }}>{T("next")}</span>
          </Button>
        </Box>
      </Box>
    </div>
  );
}

export default CreateGroupStepPII;
